/* Eight Saints Dawn page behavior. Scoped and reinitialized on Theme Editor section reload. */
(() => {
  if (customElements.get('es-eye-system')) return;
  class EightSaintsPage extends HTMLElement {
    connectedCallback() {
      if (this._abort) return;
      this._abort = new AbortController();
      const connection = this._abort;
      this._cleanups = [];
      queueMicrotask(() => {
        if (!this.isConnected || connection.signal.aborted) return;
        const root = this;
        const listen = (target, type, handler, options = {}) => {
          target.addEventListener(type, handler, { ...options, signal: connection.signal });
          if (type === 'pagehide') this._cleanups.push(handler);
        };
const OFFER = JSON.parse(root.querySelector("[data-offer-config]").textContent);
const PLANS = OFFER.plans;
const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:OFFER.currency}).format(cents / 100);
let selectedMonths = 3;
let isSubscribe = true;
const quiz = root.querySelector('[data-quiz]');
const quizResult = root.querySelector('.quiz-result');
const quizInputs = [...root.querySelectorAll('.quiz-options input')];
const quizSubmit = root.querySelector('.quiz-submit');
quizInputs.forEach(input => listen(input,'change', () => {
  const checked = quizInputs.filter(item => item.checked);
  quizSubmit.disabled = !checked.length;
  quizSubmit.textContent = checked.length ? 'See my options →' : 'Choose at least one concern';
}));
listen(quizSubmit,'click', () => {
  const concerns = quizInputs.filter(item => item.checked).map(item => item.value.toLowerCase());
  if (!concerns.length) return;
  root.querySelector('[data-concern-summary]').textContent = 'For your focus on ' + concerns.join(', ') + ': layer Tide & True and All In, then add Bank On It to your daily routine.';
  quiz.hidden = true;
  quizResult.hidden = false;
  quizResult.querySelector('h2').setAttribute('tabindex','-1');
  quizResult.querySelector('h2').focus({preventScroll:true});
});
listen(root.querySelector('[data-reset-quiz]'),'click', () => {
  quizResult.hidden = true; quiz.hidden = false; quizInputs[0].focus({preventScroll:true});
});
function updateOffer() {
  const plan = PLANS[selectedMonths];
  root.querySelectorAll('[data-offer]').forEach(root => {
    root.querySelectorAll('.package').forEach(button => {
      const active = Number(button.dataset.months) === selectedMonths;
      const buttonPlan = PLANS[button.dataset.months];
      button.classList.toggle('selected', active);
      button.setAttribute('aria-checked', String(active));
      button.tabIndex = active ? 0 : -1;
      const monthlyPrice = button.querySelector(':scope > span:not(.package-products)');
      const totalPrice = button.querySelector(':scope > b');
      const saveLabel = button.querySelector('.package-save');
      const buttonPrice = isSubscribe ? buttonPlan.priceCents : buttonPlan.oneTimePriceCents;
      const savingPercentage = isSubscribe
        ? buttonPlan.savingPercentage
        : buttonPlan.compareAtPriceCents > buttonPrice
          ? Math.round((buttonPlan.compareAtPriceCents - buttonPrice) * 100 / buttonPlan.compareAtPriceCents)
          : 0;
      if (monthlyPrice) monthlyPrice.textContent = money(Math.round(buttonPrice / buttonPlan.months));
      if (totalPrice) totalPrice.textContent = money(buttonPrice) + ' total';
      if (saveLabel) {
        saveLabel.hidden = !savingPercentage;
        saveLabel.textContent = 'SAVE ' + savingPercentage + '%';
      }
    });
    root.querySelectorAll('.gifts-wrapper').forEach(giftsWrapper => {
      const gifts = [...giftsWrapper.querySelectorAll('.gift')];
      const giftCount = gifts.length;
      const unlocked = selectedMonths >= 2 ? giftCount : isSubscribe ? Math.min(giftCount, 1) : 0;
      gifts.forEach((gift,index) => {
        gift.classList.toggle('unlocked', index < unlocked);
        gift.querySelector('.gift-status').textContent = index < unlocked ? '✓' : '✗';
      });
      giftsWrapper.querySelector('[data-unlocked]').textContent = unlocked + ' of ' + giftCount + ' unlocked';
      giftsWrapper.querySelector('.progress i').style.width = (giftCount ? unlocked / giftCount * 100 : 0) + '%';
      giftsWrapper.querySelector('[data-gift-note]').textContent = isSubscribe
        ? 'Free shipping with every subscription. Gifts with 2- or 3-month plans.'
        : selectedMonths >= 2
          ? 'Free shipping and gifts with your 2- or 3-month one-time purchase.'
          : 'No free gifts or free shipping with a 1-month one-time purchase.';
    });
    root.querySelector('[data-order-assurance]').textContent = isSubscribe || selectedMonths >= 2
      ? 'Free shipping · 30-day money-back guarantee'
      : '30-day money-back guarantee';
    const checkoutStatus = root.querySelector('[data-checkout-status]');
    if (checkoutStatus) {
      checkoutStatus.textContent = '';
      checkoutStatus.hidden = true;
    }
    const oneTimePrice = money(plan.oneTimePriceCents / plan.quantity);
    root.querySelector('[data-savings]').textContent = isSubscribe
      ? plan.savingPercentage ? 'Save ' + plan.savingPercentage + '% with the ' + selectedMonths + '-month supply.' : 'All three products in one complete routine.'
      : 'One-Time Purchase - ' + oneTimePrice + '/each';
    const subscriptionSummary = root.querySelector('[data-subscription-summary]');
    if (subscriptionSummary) subscriptionSummary.textContent = isSubscribe
      ? 'Subscribe & Save - Every 30 Days - ' + plan.savingPercentage + '% off'
      : 'One-Time Purchase - ' + oneTimePrice + '/each';
    root.querySelector('.gp-membership-sub')?.toggleAttribute('hidden', !isSubscribe);
    root.querySelector('.gp-membership-once')?.toggleAttribute('hidden', isSubscribe);
    const membershipSaving = root.querySelector('[data-membership-saving]');
    if (membershipSaving) membershipSaving.textContent = 'Save ' + plan.savingPercentage + '% forever';
    const membershipRenewal = root.querySelector('[data-membership-renewal]');
    if (membershipRenewal) membershipRenewal.textContent = 'Renews every ' + (selectedMonths * 30) + ' days';
    const buyOnceButton = root.querySelector('.gp-buy-once-btn');
    if (buyOnceButton) {
      buyOnceButton.textContent = isSubscribe
        ? 'TRY IT ONCE — NO AUTOSHIP, ' + oneTimePrice + ' EACH'
        : '← Back to Subscribe & Save';
      buyOnceButton.disabled = !plan.available;
      buyOnceButton.setAttribute('aria-pressed', String(!isSubscribe));
    }
    const checkout = root.querySelector('[data-checkout]');
    checkout.textContent = plan.variantId && !plan.available ? 'Sold out' : 'Try risk Free →';
    checkout.disabled = Boolean(plan.variantId && !plan.available);
  });
  root.querySelectorAll('[data-hero-gift-copy]').forEach(copy => {
    copy.textContent = selectedMonths >= 2
      ? 'WITH 4 FREE GIFTS'
      : isSubscribe ? 'FREE SHIPPING INCLUDED' : 'NO FREE GIFTS';
  });
  const maxSaving = Math.max(...Object.values(PLANS).map(plan => isSubscribe
    ? plan.savingPercentage
    : plan.compareAtPriceCents > plan.oneTimePriceCents
      ? Math.round((plan.compareAtPriceCents - plan.oneTimePriceCents) * 100 / plan.compareAtPriceCents)
      : 0));
  root.querySelectorAll('[data-hero-savings]').forEach(copy => {
    copy.textContent = maxSaving + '% OFF';
    copy.hidden = !maxSaving;
  });
}
root.querySelectorAll('.package').forEach(button => {
  listen(button,'click', () => { selectedMonths=Number(button.dataset.months); updateOffer(); });
  listen(button,'keydown', event => {
    if (!['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End'].includes(event.key)) return;
    event.preventDefault();
    const siblings=[...button.parentElement.querySelectorAll('.package')];
    let index=siblings.indexOf(button);
    if(event.key==='Home') index=0;
    else if(event.key==='End') index=siblings.length-1;
    else index=(index+(event.key==='ArrowRight'||event.key==='ArrowDown'?1:-1)+siblings.length)%siblings.length;
    siblings[index].click(); siblings[index].focus();
  });
});
root.querySelectorAll('.gp-buy-once-btn').forEach(button=>listen(button,'click',()=>{
  if(isAddingToCart) return;
  isSubscribe=!isSubscribe;
  updateOffer();
}));
root.querySelectorAll('[data-gallery]').forEach(root => {
  const note = root.querySelector('[data-gallery-note]');
  const defaultNote = note.textContent;
  root.querySelectorAll('[data-gallery-prev], [data-gallery-next]').forEach(arrow => listen(arrow,'click', () => {
    const thumbs = [...root.querySelectorAll('.thumb')];
    const index = thumbs.findIndex(thumb => thumb.classList.contains('active'));
    const direction = arrow.hasAttribute('data-gallery-next') ? 1 : -1;
    thumbs[(index + direction + thumbs.length) % thumbs.length].click();
  }));
  root.querySelectorAll('.thumb').forEach(button => listen(button,'click', () => {
    root.querySelectorAll('.thumb').forEach(item=>{item.classList.remove('active');item.setAttribute('aria-pressed','false');});
    button.classList.add('active'); button.setAttribute('aria-pressed','true');
    const isSystem=button.dataset.image==='system';
    root.querySelector('[data-system-view]').hidden=!isSystem;
    const image=root.querySelector('[data-gallery-detail]');
    image.hidden=isSystem;
    if(!isSystem){image.src=button.dataset.imageUrl;image.alt=button.dataset.alt;}
    note.textContent = button.dataset.caption || defaultNote;
    const strip = root.querySelector('.thumb-row');
    const stripBounds = strip.getBoundingClientRect();
    const thumbBounds = button.getBoundingClientRect();
    const offset = thumbBounds.left < stripBounds.left ? thumbBounds.left - stripBounds.left : thumbBounds.right > stripBounds.right ? thumbBounds.right - stripBounds.right : 0;
    if (offset) strip.scrollBy({left: offset, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
  }));
});
let isAddingToCart=false;
listen(window,'pageshow', event => {
  if (!event.persisted) return;
  isAddingToCart=false;
  updateOffer();
});
async function clearCart() {
  const rootUrl=window.Shopify?.routes?.root || '/';
  const response=await fetch(rootUrl+'cart/clear.js',{
    method:'POST',
    headers:{'Accept':'application/json','Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
    body:JSON.stringify({})
  });
  if(!response.ok) throw new Error('Your cart could not be cleared. Please try again.');
}
root.querySelectorAll('[data-checkout]').forEach(button=>listen(button,'click',async()=>{
  if(isAddingToCart) return;
  const plan=PLANS[selectedMonths];
  if(isSubscribe && !plan.variantId && plan.checkoutUrl){
    const destination = new URL(plan.checkoutUrl, window.location.origin);
    if (['https:', 'http:'].includes(destination.protocol)) { window.location.assign(destination.href); return; }
  }
  const status=button.parentElement.querySelector('[data-checkout-status]');
  status.hidden=false;
  if(!plan.variantId) {
    status.textContent='Select the eye system product in the theme editor to enable checkout.';
    return;
  }
  if(isSubscribe && !plan.sellingPlanId) {
    status.textContent='A subscription plan is not available for this supply yet. Please choose a one-time purchase.';
    return;
  }
  isAddingToCart=true;
  root.querySelectorAll('[data-checkout]').forEach(checkout=>{
    checkout.disabled=true;
    checkout.textContent='Adding to cart…';
  });
  root.querySelectorAll('.gp-buy-once-btn').forEach(checkout=>{ checkout.disabled=true; });
  status.textContent='Adding '+(OFFER.productTitle || 'your selection')+' to your cart…';
  try {
    await clearCart();
    const cartAddUrl=(window.Shopify?.routes?.root || '/')+'cart/add.js';
    const item={id:plan.variantId,quantity:plan.quantity,properties:{_purchase_type:isSubscribe?'subscription':'one-time'}};
    if(isSubscribe || selectedMonths >= 2) item.properties._inside_out_eye_system=true;
    if(isSubscribe && plan.sellingPlanId) item.selling_plan=plan.sellingPlanId;
    const items=[item];
    if(selectedMonths >= 2) {
      OFFER.gifts.forEach(gift=>items.push({id:gift.variantId,quantity:1,properties:{_inside_out_eye_free_gift:'true'}}));
    }
    const response=await fetch(cartAddUrl,{
      method:'POST',
      headers:{'Accept':'application/json','Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
      body:JSON.stringify({items})
    });
    const responseText=await response.text();
    let cartData;
    try {
      cartData=JSON.parse(responseText);
    } catch {
      throw new Error('The cart returned an unexpected response. Please refresh the page and try again.');
    }
    if(!response.ok) throw new Error(cartData.description || 'This selection could not be added to the cart.');
    window.location.assign((window.Shopify?.routes?.root || '/')+'checkout');
  } catch(error) {
    isAddingToCart=false;
    updateOffer();
    status.hidden=false;
    status.textContent=error.message || 'This selection could not be added to the cart. Please try again.';
  }
}));
updateOffer();

// Fictional result images are layout placeholders. Replace before public launch.
root.querySelectorAll('[data-comparison]').forEach(root => {
  const range = root.querySelector('.comparison-range');
  const setPosition = () => {
    root.style.setProperty('--position', range.value + '%');
    range.setAttribute('aria-valuetext', range.value + '% before image visible');
  };
  listen(range,'input', setPosition);
  setPosition();
});

root.querySelectorAll('.testimonial-video').forEach(card => {
  const video = card.querySelector('video');
  const play = card.querySelector('[data-video-play]');
  const sound = card.querySelector('[data-video-sound]');
  listen(play,'click', async () => {
    if (!video.paused) { video.pause(); return; }
    root.querySelectorAll('[data-testimonial-video]').forEach(other => { if (other !== video) other.pause(); });
    video.controls = true;
    try { await video.play(); } catch { play.textContent = '▶'; video.controls = true; }
  });
  listen(video,'play', () => { play.hidden = true; sound.hidden = !video.muted; });
  listen(video,'pause', () => { play.hidden = false; sound.hidden = true; });
  listen(video,'ended', () => { play.hidden = false; sound.hidden = true; });
  listen(sound,'click', () => { video.muted = false; sound.hidden = true; });
});

// User-supplied mockup percentages, not measured system results.
// Match the reference's scroll-linked card unfolding and 1100ms counters.
const statsSection = root.querySelector('[data-stats]');
if (statsSection) {
  const grid = statsSection.querySelector('.stats-grid');
  const cards = [...grid.querySelectorAll('.stat-tile')];
  const counters = [...grid.querySelectorAll('[data-stat-target]')];
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const desktop = window.matchMedia('(min-width: 992px)');
  let frame = 0, progress = null, lastTime = 0;
  const counterFrames = new Map();
  function targetProgress() {
    const rect = grid.getBoundingClientRect();
    const start = desktop.matches ? .75 : .9;
    const end = desktop.matches ? .4 : .25;
    return Math.max(0, Math.min(1, (innerHeight * start - rect.top) / (rect.height + innerHeight * (start - end))));
  }
  function paint(value) {
    const eased = 1 - Math.pow(1 - value, 2);
    if (desktop.matches) {
      cards[0].style.transform = 'translateX(' + ((1 - eased) * 100) + '%) rotate(-5deg)';
      cards[1].style.transform = 'rotate(' + (2.8 * (1 - eased)) + 'deg)';
      cards[2].style.transform = 'translateX(' + (-100 * (1 - eased)) + '%) rotate(' + (-6.3 + 11.3 * eased) + 'deg)';
    } else {
      cards[0].style.transform = 'rotate(' + (-3 * eased) + 'deg)';
      cards[1].style.transform = 'translateY(' + (-105 * (1 - eased)) + '%) rotate(' + (1.5 * eased) + 'deg)';
      cards[2].style.transform = 'translateY(' + (-210 * (1 - eased)) + '%) rotate(' + (-2.5 * eased) + 'deg)';
    }
  }
  function tick(now) {
    frame = 0;
    if (reducedMotion.matches) {
      cards.forEach(card => card.style.removeProperty('transform'));
      return;
    }
    const target = targetProgress();
    const delta = lastTime ? Math.min(now - lastTime, 64) : 16;
    lastTime = now;
    progress = progress === null ? target : progress + (target - progress) * (1 - Math.exp(-delta / 180));
    if (Math.abs(target - progress) < .0005) progress = target;
    paint(progress);
    if (progress !== target) frame = requestAnimationFrame(tick);
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(tick); }
  function countUp(element) {
    cancelAnimationFrame(counterFrames.get(element));
    const target = Number(element.dataset.statTarget);
    if (reducedMotion.matches) { element.textContent = target + '%'; return; }
    const started = performance.now();
    element.textContent = '0%';
    function count(now) {
      const portion = Math.min((now - started) / 1100, 1);
      element.textContent = Math.floor(target * portion) + '%';
      if (portion < 1) counterFrames.set(element, requestAnimationFrame(count));
      else counterFrames.delete(element);
    }
    counterFrames.set(element, requestAnimationFrame(count));
  }
  const counterObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => { if (entry.isIntersecting) countUp(entry.target); });
  }, { rootMargin: '0px 0px -15% 0px', threshold: 0 });
  counters.forEach(counter => counterObserver.observe(counter));
  listen(window,'scroll', schedule, { passive: true });
  listen(window,'resize', schedule, { passive: true });
  listen(reducedMotion,'change', () => { counters.forEach(countUp); schedule(); });
  listen(desktop,'change', () => { progress = null; schedule(); });
  schedule();
  listen(window,'pagehide', () => {
    cancelAnimationFrame(frame);
    counterFrames.forEach(cancelAnimationFrame);
    counterObserver.disconnect();
  }, { once: true });
}




      });
    }
    disconnectedCallback() {
      this._abort?.abort();
      this._cleanups?.forEach(cleanup => cleanup());
      this.querySelectorAll('video').forEach(video => video.pause());
      this._abort = null;
    }
  }
  customElements.define('es-eye-system', EightSaintsPage);
})();